import { useState, useEffect } from "react";
import { is, string, type } from "superstruct";
import {
  CUSTOM_EVENT_TRACK_VIEW_DATA,
  CustomEventDetailTrackViewData,
} from "@rea-argonaut/analytics";

let initialPageName: string | undefined;

const PageDataStruct = type({
  page: type({
    data: type({
      page_name: string(),
    }),
  }),
});

const getPageName = (event: CustomEvent<CustomEventDetailTrackViewData>) => {
  const viewData = event.detail.viewData;
  if (is(viewData, PageDataStruct)) {
    return viewData.page.data.page_name;
  }
};

const listenerForInitialState = ((
  event: CustomEvent<CustomEventDetailTrackViewData>,
) => {
  initialPageName = getPageName(event);
}) as EventListener;

if (typeof document === "object") {
  document.addEventListener(
    CUSTOM_EVENT_TRACK_VIEW_DATA,
    listenerForInitialState,
  );
}

export const usePageName = (): string | undefined => {
  const [pageName, setPageName] = useState(initialPageName);

  useEffect(() => {
    const listener = ((event: CustomEvent<CustomEventDetailTrackViewData>) => {
      setPageName(getPageName(event));
    }) as EventListener;
    document.addEventListener(CUSTOM_EVENT_TRACK_VIEW_DATA, listener);

    return function cleanup() {
      document.removeEventListener(CUSTOM_EVENT_TRACK_VIEW_DATA, listener);
    };
  }, []);

  return pageName;
};
